import { AdminUsersPage } from './../pages/admin-users/admin-users';
import { Component, ViewChild } from '@angular/core';
import { Platform, Nav, Events } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { DeveloperProvider } from "../providers/developers";
import { GlobalVariables } from "../variables/global";
import { AdminUsersDetailPage } from "../pages/admin-users-detail/admin-users-detail";
import { CustomErrorHandler } from "@questrade/flx-commons";
import { Network } from '@ionic-native/network';
import { FlxModalProvider } from '@questrade/flx-commons';
import * as properties from './../properties/keys';
import { environment } from './../environments/environment';

@Component({
  templateUrl: 'app.html'
})
export class FlxDeveloperPortal {

  private userPageDescription: string;
  private logo: string;
  private isAdmin: boolean;
  private loginImage: string;
  private initialPage: number = 1;
  private modal: any;
  public userIsLogged: boolean = false;
  public rootPage: any = "login";
  public menuList;
  public slideItemsState = [];

  @ViewChild(Nav) nav: Nav;

  constructor(
    private platform: Platform,
    private statusBar: StatusBar,
    private splashScreen: SplashScreen,
    private devProvider: DeveloperProvider,
    private events: Events,
    private customErrorHandler: CustomErrorHandler,
    private flxModal: FlxModalProvider,
    private network: Network) {

    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.logo = 'assets/logo.png';
      this.loginImage = 'assets/loginImage.jpg';
    });

    //redirect to login event
    this.events.subscribe('app:error:redirect:index', (nav) => {
      if (nav) this.nav = nav;
      this.redirectToIndexPage();
    });

    this.addConnectivityListeners();

    this.postMenuList();

    this.initializePasswordPolicies();

    this.listenEvents();
  }

  ngOnInit() {

  }

  initializePasswordPolicies() {
    this.devProvider.getPasswordPolicies().subscribe(response => {
      GlobalVariables.passwordPolicies = JSON.stringify(response);
    })
  }

  postMenuList() {
    /*
      Menu list
                 */
    let pagesList = GlobalVariables.pages;
    this.menuList = [
      {
        ...pagesList.userAccount,
        text: this.userPageDescription
      },
      {
        ...pagesList.apiDocs,
        condition: !this.isAdmin
      },
      {
        ...pagesList.extensions,
        subItems: [
          {
            ...pagesList.extMagento1
          },
          {
            ...pagesList.extMagento2,
            condition: (environment.name === 'local')
          }
        ]
      },
      { ...pagesList.sdk },
      { ...pagesList.sandbox }
    ];
  }

  slideItem(index) {
    if (this.slideItemsState[index] === undefined || !this.slideItemsState[index]) {
      this.slideItemsState[index] = true;
    } else {
      this.slideItemsState[index] = false;
    }
  }

  addConnectivityListeners() {
    // watch network for a disconnect
    this.network.onDisconnect().subscribe(() => {
      this.openModal();
    });

    // watch network for a connect
    this.network.onConnect().subscribe(() => {
      if (this.modal) {
        this.modal.dismiss();
      }
    });
  }

  openModal() {
    let modalProps = {
      title: properties['offline'][document.documentElement.lang],
      onlyHasInformation: 'true',
      notAbleToClose: true
    };
    this.modal = this.flxModal.create(modalProps);
  }

  redirectToIndexPage() {
    if (this.nav && this.nav.getActive().component.name != 'IndexPage') {
      this.splashScreen.show();
      window.location.reload();
    }
  }

  ngOnDestroy() {
    this.events.unsubscribe('menu:changed');
    this.events.unsubscribe('app:error:redirect:index');

    this.cleanEvents();
  }

  goTo(pageName) {
    switch (pageName) {
      case 'user-account':
        this.goToAdminPage();
        break;
      default:
        this.nav.push(pageName);
        break;
    }
  }

  slideAndGo(link, index) {
    this.slideItem(index);
    this.goTo(link);
  }

  goToAdminPage() {
    if (GlobalVariables.accessType === 'ADMIN') {
      this.nav.setRoot('admin-users');
    } else {
      this.nav.setRoot('admin-users-detail');
    }
  }

  getUsers() {
    this.devProvider.getUsers(this.initialPage)
      .subscribe(data => {
        this.nav.setRoot(AdminUsersPage, { users: data.developers, admin: GlobalVariables.username });
      }, error => {
        this.customErrorHandler.handleError(error.json());
      })

  }

  getUser() {
    this.devProvider.getUser(GlobalVariables.username)
      .subscribe(data => {
        this.nav.setRoot(AdminUsersDetailPage, { userDetail: data, accessType: 'DEV' });
      }, error => {
        this.customErrorHandler.handleError(error.json());
      })
  }

  listenEvents() {
    this.events.subscribe('user:login', data => {
      this.userIsLogged = true;
    });

    this.events.subscribe('user:logout', data => {
      this.userIsLogged = false;

      this.devProvider.logout().subscribe(data => {
        GlobalVariables.clearStorage();

        this.nav.setRoot('home');
      }, error => {
        this.customErrorHandler.handleError(error.json());
      });
    });

    this.events.subscribe('nav:go', data => {
      this.goTo(data.link);
    })
  }

  isLoggedIn() {
    const token = GlobalVariables.authToken;

    if (token) this.userIsLogged = true;
    if (!this.userIsLogged) {
      return this.nav.setRoot('login');
    }
  }

  cleanEvents() {
    this.events.unsubscribe('user:login');
    this.events.unsubscribe('user:logout');
    this.events.unsubscribe('nav:go');
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts